export const textStyles = {
  hx: {
    sizeMultiplier: 2.4,
    weight: 700,
    size: 72,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h0: {
    sizeMultiplier: 2,
    weight: 700,
    size: 40,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h1: {
    sizeMultiplier: 2.4,
    weight: 700,
    size: 32,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h2: {
    sizeMultiplier: 2,
    weight: 700,
    size: 24,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h3: {
    sizeMultiplier: 1.4,
    weight: 400,
    size: 20,
    lineHeight: 1,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h4: {
    sizeMultiplier: 1,
    weight: 700,
    size: 18,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h5: {
    sizeMultiplier: 0.8,
    weight: 700,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  h6: {
    sizeMultiplier: 0.8,
    weight: 700,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  p1: {
    sizeMultiplier: 1,
    weight: 300,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  p2: {
    sizeMultiplier: 0.8,
    weight: 300,
    size: 14,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  'p3-inter': {
    sizeMultiplier: 0.65,
    weight: 300,
    size: 14,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  p3: {
    sizeMultiplier: 0.65,
    weight: 300,
    size: 14,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  p4: {
    sizeMultiplier: 0.44,
    weight: 400,
    size: 14,
    lineHeight: 1,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  p5: {
    sizeMultiplier: 0.44,
    weight: 300,
    size: 10,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
  c2: {
    sizeMultiplier: 1,
    size: 12,
    weight: 500,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: 'ITCAvantGardeStd',
  },
}
